var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClipboardCheck = function SvgClipboardCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.667 2.664a.333.333 0 0 0-.334.333v1.334c0 .184.15.333.334.333h4.666c.184 0 .334-.15.334-.333V2.997a.333.333 0 0 0-.334-.333H9.667Zm0-2c-1.177 0-2.15.871-2.31 2.004H7a3.666 3.666 0 0 0-3.667 3.667V19A3.666 3.666 0 0 0 7 22.668h10a3.666 3.666 0 0 0 3.667-3.667V6.335A3.666 3.666 0 0 0 17 2.668h-.356a2.334 2.334 0 0 0-2.31-2.004H9.666ZM7 4.668h.357a2.334 2.334 0 0 0 2.31 1.996h4.666a2.334 2.334 0 0 0 2.31-1.996H17c.921 0 1.667.746 1.667 1.667V19c0 .921-.746 1.667-1.667 1.667H7a1.666 1.666 0 0 1-1.667-1.667V6.335c0-.921.746-1.667 1.667-1.667Zm9.467 5.6a1 1 0 1 0-1.6-1.2l-4.26 5.68-1.521-1.739a1 1 0 1 0-1.505 1.317l2.333 2.667a1 1 0 0 0 1.553-.058l5-6.667Z",
    fill: "currentColor"
  })));
};

export default SvgClipboardCheck;